const wishlistItem = {
    emits: ['remove','openSamplePopup'],
    template: `<div class="item" v-if="isAPI">
                    <span class="product-image" :style="{ backgroundImage: 'url(' + imageUrl + ')' }"></span>
                    <span title="Remove Item" class="link-wishlist added" @click="$emit('remove',product,'remove')"><i class="fa fa-times" aria-hidden="true"></i></span>
                    <button class="link-view" @click.prevent="$emit('openSamplePopup', product)">Order Sample</button>
                </div>
                <div class="item" v-else>
                    <a v-bind:href="productUrl" class="product-image" :style="{ backgroundImage: 'url(' + imageUrl + ')' }"></a>
                    <span title="Remove Item" class="link-wishlist added" @click="$emit('remove',product,'remove')"><i class="fa fa-times" aria-hidden="true"></i></span>
                    <a v-bind:href="productUrl" class="link-view">View</a>
                  </div>`,

    props: {
        product: Object
    },
    computed: {
        isAPI() {
            return this.product.type && this.product.type.includes('API');
        },
        imageUrl() {
            let img = '';
            if(this.product.thumbnail_url) {
                img = this.product.thumbnail_url;
            } else if(this.product.image) {
                img = this.product.image;
            }
            if(!img.startsWith('https')) {
                img = 'https:' + img;
            }
            return (this.product.type.toLowerCase().includes('canvas') && !img.includes(this.previewUrl)) ? this.previewUrl + img : img;
        },
        productUrl() {
            return this.product.url && this.product.url.includes('/products/') ? this.product.url : '/products/' + this.product.url;
        }
    }
}
const wishlistViewItem = {
    emits: ['remove','openSamplePopup'],
    template: `<li class="item default-item" v-if="isAPI">
                    <div class="item-image" :style="{ backgroundImage: 'url(' + imageUrl + ')' }"></div>
                    <a :href="'/collections/explore?id='+product.id" class="product-name">{{product.title}}</a>
                    <span class="product-id">Item # {{product.id}}</span>
                    <div class="item-details">
                        <div class="add-to-links">
                            <button class="product-button" @click.prevent="$emit('openSamplePopup', product)">Order Sample</button>
                            <span title="Remove Item" class="link-wishlist added" @click="$emit('remove',product)"><i class="fa fa-trash" aria-hidden="true"></i></span>
                        </div>
                    </div>
                </li>
                <li class="item default-item" v-else>
                    <div class="item-image" :style="{ backgroundImage: 'url(' + imageUrl + ')' }"></div>
                    <a v-bind:href="productUrl" class="product-name">{{product.title}}</a>
                    <span class="product-id" v-if="product.variantSku">Item # {{product.variantSku}}</span>
                    <div class="item-details">
                        <div class="add-to-links">
                            <button class="product-button" @click.prevent="$emit('openSamplePopup', product)">Order Sample</button>
                            <a v-bind:href="productUrl" class="product-button" title="View"><i class="fa fa-eye" aria-hidden="true"></i></a>
                            <span title="Remove Item" class="link-wishlist added" @click="$emit('remove',product)"><i class="fa fa-trash" aria-hidden="true"></i></span>
                        </div>
                    </div>
                </li>`,
    props: {
        product: Object
    },
    computed: {
        isAPI() {
            return this.product.type && this.product.type.includes('API');
        },
        imageUrl() {
            let img = '';
            if(this.product.thumbnail_url) {
                img = this.product.thumbnail_url;
            } else if(this.product.image) {
                img = this.product.image;
            }
            if(!img.startsWith('https')) {
                img = 'https:' + img;
            }
            return (this.product.type.toLowerCase().includes('canvas') && !img.includes(this.previewUrl)) ? this.previewUrl + img : img;
        },
        productUrl() {
            return this.product.url && this.product.url.includes('/products/') ? this.product.url : '/products/' + this.product.url;
        }
    }
}
const wishlistLink = {
    template: `<span class="link-wishlist" :class="{added: isActive}" @click.stop.prevent="wishlistAction()"><span v-if="isProductPage">Save to Project List</span></span>
                <teleport to="#wishlistPopup" v-if="showWishlistPopup">
                  <transition name="modal">
                    <div class="modal-mask">
                      <div class="modal-wrapper" @click="closeWishlistPopup()">
                        <div class="modal-container limitless-save-popup" @click.stop="">
                          <div class="modal-header">Save To Project</div>
                          <div class="modal-body">
                            <template v-if="message">
                              <ul class="messages" ><li class="success-msg"><span>{{message}}</span></li></ul>
                              <div class="extra-actions">
                                <a class="extra-link" href="#" @click.prevent="closeWishlistPopup">Continue Browsing</a>
                                <a class="button button--primary button--full" href="/collections/wishlist">View Wishlist</a>
                              </div>
                            </template>
                            <form v-else method="post" action="" @submit.prevent="createNewProject">
                                <div class="input">
                                  <div class="select-wrapper">
                                    <select class="select" id="wishlist-project" v-model="project" ref="select_project">
                                      <option :value="null">Create a New Project</option>
                                      <option v-for="p in projects" :value="p">{{p.name}}</option>
                                    </select>
                                    <svg focusable="false" width="12" height="8" class="icon icon--chevron" viewBox="0 0 12 8"><path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="1.2"></path></svg>                   
                                  </div>
                                </div>
                                <div class="input" v-if="project === null">
                                  <input type="text" id="new-project-name" class="input__field" aria-label="Project Name *" v-model="newProjectName" ref="new_project_name" required autofocus>
                                  <label for="new-project-name" class="input__label">Project Name *</label>
                                </div>
                                <div class="input" v-if="project === null">
                                  <textarea id="new-project-description" class="input__field input__field--textarea" rows="4" aria-label="Project Description" v-model="newProjectDescription"></textarea>
                                  <label for="new-project-description" class="input__label">Project Description</label>
                                </div>
                                <div class="input">
                                  <div class="actions"><button type="submit" class="popup-button wishlist-popup-button"><span><span>Save</span></span></button></div>
                                </div>
                            </form>
                          </div>
                          <div class="modal-footer">
                          </div>
                          <button class="modal-close button button--close" @click="closeWishlistPopup()"><span class="sr-only">Close</span><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17"><path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"/></svg></button>
                        </div>
                      </div>
                    </div>
                  </transition>
                </teleport>`,
    props: {
        id: Number,
        variantId: Number,
        variantSku: String,
        variants: String,
        isProductPage: Boolean,
        type: String,
        url: String,
        image: String,
        title: String,
    },
    data() {
        return {
            productVariants: [],
            showWishlistPopup: false,
            isMounted: false,
            project: null,
            newProjectName: null,
            newProjectDescription: null,
            message: null
        }
    },
    watch: {
        project() {
            this.$nextTick(()=> {
                if(this.project === null && this.$refs['select_project'] && this.$refs['new_project_name']) {
                    this.$refs['select_project'].blur();
                    this.$refs['new_project_name'].focus();
                }
            })

        }
    },
    mounted() {
        if(this.variants) {
            try {
                this.productVariants = JSON.parse(window.atob(this.variants));
            } catch (e) {

            }
        }
        this.isMounted = true;
    },
    computed: {
        items() {
            return this.$store.getters['wishlist/items'];
        },
        projects() {
            return this.$store.getters['wishlist/projects'];
        },
        currentVariant() {
            return this.variantId && typeof this.variantId !== 'undefined' && this.productVariants.length > 0 ? this.productVariants.find((variant) => variant.id === this.variantId) : null
        },
        item() {
            return {
                'id': this.id,
                'variantId': this.variantId && typeof this.variantId !== 'undefined' ? this.variantId : null,
                'variantSku': this.variantSku ? this.variantSku : null,
                'type': this.type,
                'project': this.project ? this.project.id : null,
                'url': this.currentVariant ? this.url + '?variant=' + this.currentVariant.id : this.url,
                'image': this.currentVariant && this.currentVariant.image ? this.currentVariant.image : this.image,
                'title': this.currentVariant ? this.title + ' - ' + this.currentVariant.title : this.title,
                'variants': this.productVariants
            };
        },
        isActive() {
            const itemFound = this.items.filter(row => (
                (row.id === this.item.id || row.id === parseInt(this.item.id)) &&
                (row.variantId === this.item.variantId || row.variantId === parseInt(this.item.variantId)) &&
                row.type === this.item.type
            ));
            return itemFound.length > 0;
        }
    },
    methods: {
        wishlistAction() {
            if(this.isActive) {
                this.$store.dispatch('wishlist/remove', {
                    item: this.item
                })
            } else {
                if(this.projects && this.projects.length > 0) {
                    this.project = this.projects[0];
                }
                this.showWishlistPopup = true;
            }
        },
        createNewProject() {
            if(!this.project && this.newProjectName) {
                const newProject = {
                    'id': Date.now(),
                    'date': new Date().toLocaleString(),
                    'name': this.newProjectName
                };
                if(this.newProjectDescription) {
                    let desc = this.newProjectDescription.replace(/(<([^>]+)>)/ig, '');
                    desc = desc.replace(/(\r\n|\n|\r)/gm," ");
                    desc = desc.replace(/\s+/g," ");
                    newProject['description'] = desc.trim().substring(0, 255);
                }
                this.project = newProject;
                this.$store.dispatch('wishlist/addProject', {
                    project: this.project
                });
                this.$store.dispatch('wishlist/add', {
                    item: this.item
                });
                this.newProjectName = null;
                this.newProjectDescription = null;
                this.message = this.item.title + ' was added to your project.';
            } else if(this.project) {
                this.$store.dispatch('wishlist/add', {
                    item: this.item
                });
                this.message = this.item.title + ' was added to your project.';
            }
        },
        closeWishlistPopup() {
            this.showWishlistPopup = false;
            this.message = null;
        }
    }
}
const loadWishlist = {
    template: `
    <div class="empty-wishlist" v-if="itemsCount === 0 && projects.length === 0">
        <p class="sub-title">There's nothing in your wishlist!</p>
        <p><a class="button" href="/collections/wall-mural">Shop Murals</a></p>
        <template v-if="!isCustomer">
        <p class="hr-separator"><span>or</span></p>
        <p class="sub-title">Load a Saved Wishlist</p>
        <p>Access a saved wishlist by logging into your account.</p>
        <div class="actions">
            <a href="/account/login?ref=wishlist" class="button button--primary button--full">Login</a>
        </div>
        </template>
    </div>`,
    data() {
        return {
            localErrors: [],
            loading: false,
            email: ''
        }
    },
    computed: {
        items() {
            return this.$store.getters['wishlist/items'];
        },
        projects() {
            return store.getters['wishlist/projects'];
        },
        itemsCount() {
            return this.items.length;
        },
        isCustomer() {
            return window.isCustomerLoggedIn;
        }
    },
    methods: {
        load() {

        }
    }
}
const wishlistViewApp = Vue.createApp({
    components: {
        'loadwishlist': loadWishlist,
        'wishlistviewitem': wishlistViewItem,
        'sample': samplePopup,
    },
    data() {
        return {
            hash: null,
            loading: false,
            sampleItem: null,
            type: 'mural',
            showSamplePopup: false,
            shareDisabled: true,
            activeProject: null
        }
    },
    created() {
    },
    watch: {
        projects: {
            handler(newValue) {
                if(this.activeProject === null) {
                    this.updateProjects()
                }
                this.$nextTick(()=> {
                    if(this.activeProject === null) {
                        this.updateProjects()
                    }
                });
            },
            immediate: true
        }
    },
    mounted () {
    },
    computed: {
        items() {
            return store.getters['wishlist/items'];
        },
        activeItems() {
            return this.activeProject && this.items ? this.items.filter((i) => i.project === this.activeProject.id) : [];
        },
        projects() {
            return store.getters['wishlist/projects'];
        },
        itemsCount() {
            return this.items.length;
        },
    },
    methods: {
        save() {
            try {
                const event = new Event('wishlist:save');
                window.dispatchEvent(event);
            } catch(e) {
                console.error(e);
            }
        },
        share() {
            try {
                const event = new Event('wishlist:share');
                window.dispatchEvent(event);
            } catch(e) {
                console.error(e);
            }
        },
        clear() {
            if(this.activeProject) {
                if(confirm("Do you really want to remove all items from this project?")) {
                    this.items.forEach((item) => {
                        if(item.hasOwnProperty('project') && item.project === this.activeProject.id) {
                            this.remove(item);
                        }
                    });
                }
            }
        },
        remove(item) {
            if(item) {
                store.dispatch('wishlist/remove', {
                    item: item
                })
            }
        },
        updateProjects() {
            this.activeProject = this.projects && this.projects.length > 0 ? this.projects[0] : null;
            this.loading = false;
        },
        removeProject(project) {
            if(confirm("Do you really want to remove this project?")) {
                if(project) {
                    this.loading = true;
                    this.items.forEach((item) => {
                        if(item.hasOwnProperty('project') && item.project === project.id) {
                            this.remove(item);
                        }
                    });
                    store.dispatch('wishlist/removeProject', {
                        project: project
                    });
                    this.updateProjects();
                }
            }
        },
        shareProject(project) {
            if(project) {
                store.dispatch('wishlist/shareProject', {
                    project: project
                });
            }
        },
        openSamplePopup(product) {
            this.sampleItem = product;
            this.showSamplePopup = true;
        },
        closeSamplePopup() {
            this.showSamplePopup = false;
        },
    },
    template: `<div class="my-wishlist" :class="{'limitless-loading': loading}">
    <div class="page-title title-buttons">
      <h1><i class="fa fa-heart" aria-hidden="true"></i> My Projects & Saved Samples (<span>{{itemsCount}}</span>)</h1>
      <div class="actions">
        <span class="wishlist-button" v-if="!true" @click="save" :class="{disabled: itemsCount === 0 }"><span>Save</span></span>
        <span class="wishlist-button" v-if="!shareDisabled" @click="share" :class="{disabled: (itemsCount === 0 || shareDisabled) }"><span>Share</span></span>
        <span class="wishlist-button" v-if="!true" @click="clear" :class="{disabled: itemsCount === 0 || !activeProject }"><span>Clear</span></span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="input visible-xs mb-4">
          <div class="d-flex">
            <div class="select-wrapper flex-fill">
              <select class="select" v-model="activeProject" v-if="activeProject && projects.length > 0">
                <option v-for="project in projects" :value="project">{{project.name}}</option>
              </select>
              <svg focusable="false" width="12" height="8" class="icon icon--chevron" viewBox="0 0 12 8"><path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="1.2"></path></svg>
            </div>
            <div class="d-flex ms-2" v-if="activeProject">
              <button v-if="activeItems && activeItems.length > 0" class="button button--small button--text button--outline me-2" @click.stop="shareProject(activeProject)"><i class="fa fa-envelope" aria-hidden="true"></i></button>
              <button class="button button--small button--text button--outline" @click.stop="removeProject(activeProject)"><i class="fa fa-trash" aria-hidden="true"></i></button>
            </div>
          </div>
        </div>
        <ul class="wishlist-projects hidden-xs" v-if="activeProject && projects.length > 0">
          <li v-for="project in projects" :key="project.id">
            <div @click="activeProject = project" :class="{'active': activeProject && activeProject.id === project.id}">
              <h3>{{project.name}}</h3>
              <p v-if="project.description">{{project.description}}</p>
              <p>Created: {{project.date}}</p>
              <p class="d-flex" v-if="activeProject && activeProject.id === project.id">
                <button v-if="activeItems && activeItems.length > 0" class="button button--small button--text button--outline me-2" @click.stop="shareProject(activeProject)"><i class="fa fa-envelope" aria-hidden="true"></i></button>
                <button class="button button--small button--text button--outline" @click.stop="removeProject(project)"><i class="fa fa-trash" aria-hidden="true"></i></button>
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div class="col-md-9">
        <ul class="wishlist-list products-grid" v-if="activeProject && activeItems && activeItems.length > 0">
          <wishlistviewitem
            v-for="item in activeItems"
            :key="item.id"
            :product="item"
            @remove="remove"
            @open-sample-popup="openSamplePopup"
          ></wishlistviewitem>
        </ul>
        <div v-if="activeProject && (!activeItems || activeItems.length === 0)">This project doesn't have any items.</div>
      </div>
    </div>
    <loadwishlist></loadwishlist>
  </div>
  <sample :show="showSamplePopup" :item="sampleItem" :type="type" @close="closeSamplePopup"></sample>`
})
wishlistViewApp.use(AdobeClientPlugin).use(store);
wishlistViewApp.config.compilerOptions.isCustomElement = tag => tag.includes('-') && !tag.includes('router')
wishlistViewApp.config.unwrapInjectedRef = true
if(document.getElementById('my-wishlist')) {
    wishlistViewApp.mount('#my-wishlist');
}
const loginWishlistComponent = {
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        close() {
            this.$emit('closeModal');
        },
    },
    template: `<div class="modal-mask">
      <div class="modal-wrapper" @click="close()">
        <div class="modal-container limitless-save-popup" :class="{'limitless-loading': loading}" @click.stop="">
          <div class="modal-header">Login</div>
          <div class="modal-body">
            <p>Please log in or create an account to save your wishlist items.</p>
            <p><a href="/account/login?ref=wishlist" class="button button--primary button--full">Login</a></p>
            <p><a href="/account/register?ref=wishlist" class="button button--outline button--full">Create Account</a></p>
          </div>
          <div class="modal-footer">
          </div>
          <button class="modal-close button button--close" @click="close()"><span class="sr-only">Close</span><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17"><path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"/></svg></button>
        </div>
      </div>
    </div>`,
}
const saveWishlistComponent = {
    data() {
        return {
            email: localStorage.getItem('limitlesswalls_wishlist_email'),
            isError: false,
            loading: false,
        }
    },
    template: `<div class="modal-mask">
      <div class="modal-wrapper" @click="close()">
        <div class="modal-container limitless-save-popup" :class="{'limitless-loading': loading}" @click.stop="">
          <div class="modal-header">Save your Wishlist</div>
          <div class="modal-body">
            <p>Come back to your wishlist later, access it from another device, or share it with others easily. No account needed, simply enter your email address and your list will be saved.</p>
            <form method="post" action="" @submit.prevent="save">
                <div>
                  <input type="email" class="input-text required-entry validate-email" v-model="email" @click="isError = false" placeholder="Your Email Address*">
                  <div class="validation-advice" v-if="isError">This is a required field.</div>
                </div>
                <div class="actions">
                  <button type="submit" class="popup-button wishlist-popup-button"><span><span>Save Wishlist</span></span></button>
                </div>
            </form>
            <p>Looking for a saved wishlist? <a href="#" class="wishlist-action" data-action="load">Load Wishlist</a></p>
          </div>
          <div class="modal-footer">
          </div>
          <button class="modal-close button button--close" @click="close()"><span class="sr-only">Close</span><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17"><path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"/></svg></button>
        </div>
      </div>
    </div>`,
    computed: {
        items() {
            return this.$store.getters['wishlist/items'];
        },
        itemsCount() {
            return this.items.length;
        }
    },
    methods: {
        close() {
            this.$emit('closeModal');
        },
        save() {

        }
    }
}
const shareWishlistComponent = {
    data() {
        return {
            to: '',
            from: window.customerEmail,
            name: window.customerName,
            message: '',
            copy: 'no',
            isError: {
                'to': false,
                'from': false,
                'name': false,
            },
            loading: false,
        }
    },
    template: `<div class="modal-mask">
      <div class="modal-wrapper" @click="close()">
        <div class="modal-container limitless-save-popup limitless-share-popup" :class="{'limitless-loading': loading}" @click.stop="">
          <div class="modal-header">Share your Project "{{project.name}}"</div>
          <div class="modal-body">
            <form method="post" action="" @submit.prevent="share">
              <div class="row">
                <div class="col-sm-6">
                  <input type="text" class="input-text required-entry" placeholder="Your Name*" v-model="name" @click="isError.name = false">
                  <div class="validation-advice" v-if="isError.name">This is a required field.</div>
                </div>
                <div class="col-sm-6">
                  <input type="email" class="input-text required-entry validate-email" placeholder="Your Email Address*" v-model="from" @click="isError.from = false">
                  <div class="validation-advice" v-if="isError.from">This is a required field.</div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <input type="text" class="input-text required-entry" placeholder="Recipient's Email Address*" v-model="to" @click="isError.to = false">
                  <div class="validation-advice" v-if="isError.to">This is a required field.</div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <textarea class="input-text" cols="60" rows="2" placeholder="Message" v-model="message"></textarea>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 mb-3">
                  <div class="checkbox-container">
                    <input type="checkbox" class="checkbox" v-model="copy" true-value="yes" false-value="no" id="sendACopy">
                    <label for="sendACopy" class="text--subdued">Send myself a copy</label>
                  </div>
                </div>
              </div>
              <div class="actions">
                <button type="submit" class="popup-button wishlist-popup-button" title="Share Project"><span><span>Share Project</span></span></button>
              </div>
            </form>
          </div>
          <div class="modal-footer">
          </div>
          <button class="modal-close button button--close" @click="close()"><span class="sr-only">Close</span><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17"><path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"/></svg></button>
        </div>
      </div>
    </div>`,
    computed: {
        project() {
            return this.$store.getters['wishlist/shared'];
        },
        items() {
            return this.$store.getters['wishlist/items'];
        },
        sharedItems() {
            return this.project && this.items ? this.items.filter((i) => i.project === this.project.id) : [];
        }
    },
    methods: {
        share() {
            if(!this.to) {
                this.isError['to'] = true;
            }
            if(!this.from) {
                this.isError['from'] = true;
            }
            if(!this.name) {
                this.isError['name'] = true;
            }
            for(const key in this.isError) {
                if(this.isError[key] === true) {
                    return false;
                }
            }
            this.loading = true;
            const url = this.wishlistApiUrl + 'api/shareProject';
            let form = new FormData();
            let items = this.cloneObject(this.sharedItems);
            items.forEach((item) => {
                item.image = this.getImageUrl(item);
            })
            form.append('isAjax',true);
            form.append('project',JSON.stringify(this.project));
            form.append('items',JSON.stringify(items));
            form.append('to',this.to);
            form.append('from',this.from);
            form.append('name',this.name);
            form.append('message',this.message);
            form.append('copy',this.copy);
            fetch(url, {method: 'POST', body: form})
                .then(response => response.json())
                .then(data => {
                    this.close();
                    if(data.error) {
                        this.$store.dispatch('modal/set', {
                            'modalClass': 'modal-message',
                            'modalBody': this.errorMessage(data.error)
                        })
                        this.$store.dispatch('modal/open')
                    } else if(data.message) {
                        this.$store.dispatch('modal/set', {
                            'modalClass': 'modal-message',
                            'modalBody': this.successMessage(data.message)
                        })
                        this.$store.dispatch('modal/open')
                    }
                })
                .catch((error) => {
                    console.error(error);
                }).finally(() => {
                    this.loading = false;
                    this.close();
                });
        },
        getImageUrl(item) {
            let img = '';
            if(item.thumbnail_url) {
                img = item.thumbnail_url;
            } else if(item.image) {
                img = item.image;
            }
            if(!img.startsWith('https')) {
                img = 'https:' + img;
            }
            return (item.type.toLowerCase().includes('canvas') && !img.includes(this.previewUrl)) ? this.previewUrl + img : img;
        },
        close() {
            this.$emit('closeModal');
        },
    }
}

const wishlistApp = Vue.createApp({
    components: {
        'wishlistitem': wishlistItem,
        'savewishlist': saveWishlistComponent,
        'loginwishlist': loginWishlistComponent,
        'sharewishlist': shareWishlistComponent,
        'wishlistlink': wishlistLink,
        'sample': samplePopup,
    },
    data() {
        return {
            open: false,
            email: '',
            showSaveModal: false,
            showLoginModal: false,
            showShareModal: false,
            sampleItem: null,
            type: 'mural',
            showSamplePopup: false,
            shareDisabled: true,
            loading: false,
            isMounted: false,
            sliderOptions: {
                'dots':false,
                'arrows': true,
                'slidesToShow': 5,
                'infinite': false,
                'swipeToSlide': true,
                'responsive': [
                    {
                        'breakpoint': 992,
                        'settings': {
                            'slidesToShow': 3
                        }
                    },
                ]
            }
        }
    },
    created() {
        try {
            if(window.isCustomerLoggedIn && window.customerId) {
                const url = this.remoteApiUrl + 'Load.php';
                fetch(url, {method: 'POST', headers: this.fetchHeaders, body: JSON.stringify({'id': window.customerId})})
                    .then((response) => response.json())
                    .then((response) => {
                        if(response && response.hasOwnProperty('wishlist') && response.wishlist) {
                            const update = this.cloneObject(this.items);
                            response.wishlist.forEach((item) => {
                                if(item.hasOwnProperty('project') && item.project) {
                                    const itemFound = update.findIndex(row => (
                                        row.id === item.id &&
                                        row.variantId === item.variantId &&
                                        row.project === item.project &&
                                        row.type === item.type
                                    ));
                                    if(itemFound === -1) {
                                        update.push(item);
                                    }
                                }
                            })
                            store.dispatch('wishlist/load', {
                                items: update
                            })
                        }
                        if(response && response.hasOwnProperty('projects') && response.projects) {
                            const updateProjects = this.cloneObject(this.projects);
                            response.projects.forEach((item) => {
                                const itemFound = updateProjects.findIndex(row => (
                                    row.id === item.id
                                ));
                                if(itemFound === -1) {
                                    updateProjects.push(item);
                                }
                            })
                            store.dispatch('wishlist/loadProjects', {
                                projects: updateProjects
                            })
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                    }).finally(() => {

                    });
            }
        } catch (e) {

        }
    },
    mounted () {
        this.isMounted = true;
        window.addEventListener('wishlist:save', (event) => {
            this.save()
        });
        window.addEventListener('wishlist:autosave', (event) => {
            this.autoSave()
        });
        window.addEventListener('wishlist:share', (share) => {
            this.share()
        });
    },
    computed: {
        items() {
            return store.getters['wishlist/items'];
        },
        projects() {
            return store.getters['wishlist/projects'];
        },
        hasItems() {
            return this.items.length > 0;
        },
        itemsCount() {
            return this.items.length;
        }
    },
    methods: {
        clear() {
            if(confirm("Do you really want to remove all projects and items?")) {
                store.dispatch('wishlist/clear')
            }
        },
        autoSave() {
            return; // Disable save popup
            let saved = appCookies.get('limitlesswalls_wishlist_saved');
            saved = saved ? parseInt(saved) : 0;
            appCookies.remove('limitlesswalls_wishlist_saved');
            saved++;
            appCookies.set('limitlesswalls_wishlist_saved',saved, { expires: 1 });
            if(saved <= 2) {
                this.open = true;
                this.save();
            }
        },
        save() {
            store.dispatch('modal/close');
            if(window.isCustomerLoggedIn) {
                //this.showSaveModal = true;
                this.loading = true;
                const url = this.remoteApiUrl + 'Save.php';
                const wishlistData = {
                    'id': window.customerId,
                    'items': this.items,
                    'projects': this.projects
                };
                fetch(url, {method: 'POST', headers: this.fetchHeaders, body: JSON.stringify(wishlistData)})
                    .then((response) => response.json())
                    .then((response) => {
                        if(response) {
                            if(response.error) {
                                this.$store.dispatch('modal/set', {
                                    'modalClass': 'modal-message',
                                    'modalBody': this.errorMessage(response.error)
                                })
                                this.$store.dispatch('modal/open')
                            } else if(response.message) {
                                this.$store.dispatch('modal/set', {
                                    'modalClass': 'modal-message',
                                    'modalBody': this.successMessage(response.message)
                                })
                                this.$store.dispatch('modal/open')
                            }
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                    }).finally(() => {
                        this.loading = false;
                    });
            } else {
                this.showLoginModal = true;
            }
        },
        share() {
            store.dispatch('modal/close');
            this.showShareModal = true;
        },
        updateItem(item, action) {
            if(action === 'add') {
                this.addItem(item);
            } else if(action === 'remove') {
                this.removeItem(item);
            }
        },
        addItem(item) {
            if(item) {
                store.dispatch('wishlist/add', {
                    item: item
                })
            }
        },
        removeItem(item) {
            if(item) {
                store.dispatch('wishlist/remove', {
                    item: item
                })
            }
        },
        remove(item, action) {
            this.updateItem(item, action);
        },
        toggleWishlist() {
            this.open = !this.open;
            if(this.open) {
                this.autoSave();
            }
        },
        closeModal() {
            this.showSaveModal = false;
            this.showLoginModal = false;
            this.showShareModal = false;
        },
        openSamplePopup(product) {
            this.sampleItem = product;
            this.showSamplePopup = true;
        },
        closeSamplePopup() {
            this.showSamplePopup = false;
        },
    },
    template: `<teleport to="#wishlistAppIcon" v-if="isMounted"><a href="/collections/wishlist" class="wishlist-app-icon" :class="{'has-items':hasItems}"><svg v-if="hasItems" class="icon icon-accordion color-foreground-black" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 122.88 107.41"><g><path d="M60.83,17.19C68.84,8.84,74.45,1.62,86.79,0.21c23.17-2.66,44.48,21.06,32.78,44.41 c-3.33,6.65-10.11,14.56-17.61,22.32c-8.23,8.52-17.34,16.87-23.72,23.2l-17.4,17.26L46.46,93.56C29.16,76.9,0.95,55.93,0.02,29.95 C-0.63,11.75,13.73,0.09,30.25,0.3C45.01,0.5,51.22,7.84,60.83,17.19L60.83,17.19L60.83,17.19z"/></g></svg><svg v-else class="icon icon-accordion color-foreground-black" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20"><path d="M10 5.2393L8.5149 3.77392C6.79996 2.08174 4.01945 2.08174 2.30451 3.77392C0.589562 5.4661 0.589563 8.2097 2.30451 9.90188L10 17.4952L17.6955 9.90188C19.4104 8.2097 19.4104 5.4661 17.6955 3.77392C15.9805 2.08174 13.2 2.08174 11.4851 3.77392L10 5.2393ZM10.765 3.06343C12.8777 0.978857 16.3029 0.978856 18.4155 3.06343C20.5282 5.148 20.5282 8.52779 18.4155 10.6124L10.72 18.2057C10.3224 18.5981 9.67763 18.5981 9.27996 18.2057L1.58446 10.6124C-0.528154 8.52779 -0.528154 5.14801 1.58446 3.06343C3.69708 0.978859 7.12233 0.978858 9.23495 3.06343L10 3.81832L10.765 3.06343Z" fill-rule="evenodd"></path></svg><span v-if="hasItems">{{itemsCount}}</span></a></teleport>
    <transition name="modal">
      <loginwishlist v-if="showLoginModal" @close-modal="closeModal"></loginwishlist>
    </transition>
    <transition name="modal">
      <sharewishlist v-if="showShareModal" @close-modal="closeModal"></sharewishlist>
    </transition>`,
})

wishlistApp.use(AdobeClientPlugin).use(store);
wishlistApp.config.compilerOptions.isCustomElement = tag => tag.includes('-') && !tag.includes('router')
wishlistApp.config.unwrapInjectedRef = true
wishlistApp.mount('#wishlist-container');

window.wishlistLink = wishlistLink;
